import {useRef,useState,useEffect,useCallback} from 'react';
import {Button, Table, Spin, Modal, Col, Row,Form,Input,Select,message,Upload,DatePicker} from 'antd';
import Header from '../../../components/HeaderList';
import {getColumnSearchProps} from '../../../utils/tables';
import Editor from './Editor';
import styles from '../styles/MonitorUI.module.css';
import ImageViewer from 'react-simple-image-viewer';
import {useSelector, useDispatch} from 'react-redux';
import { getRutas, getUbicaciones,createDocument,updateDocument} from '../../../firebase/queryProvider';
import {selectUser} from '../../../redux/slices/user';
import moment from 'moment';
import instance from "../../../api/Request";
import locale from 'antd/es/date-picker/locale/es_ES';
import dayjs from 'dayjs';
import {ReactComponent as Edit} from '../../../assets/icons/edit.svg';
import {ReactComponent as Trash} from '../../../assets/icons/trash.svg';

import weekday from "dayjs/plugin/weekday"
import localeData from "dayjs/plugin/localeData"

dayjs.extend(weekday)
dayjs.extend(localeData)


const {Option} = Select;
const { TextArea } = Input;

const dateFormat = 'DD/MM/YYYY';
const customFormat = (value) => `${value.format(dateFormat)}`;

const RutasUI = props => {
  const [loading, handleLoading] = useState(true);
  const [sending, handleSending] = useState(false);
  const [form] = Form.useForm();
  const [tipificacionSelect, setTipificacionSelect] = useState([]);
  const [isModalAsignar, setIsModalAsignar] = useState(false);
  const [loadingAsignar, setLoadingAsignar] = useState(false);
  const [rutas, setRutas] = useState([]);
  const [ubicaciones, setUbicaciones] = useState([]);
  const [item, setItem] = useState(null);

  
  const dispatch = useDispatch();
  
  const user = useSelector(selectUser);

  
  const {
    newTicket,
    isModalNew,
    cancelModalNew,
    tipificacion,
  } = props;

  useEffect(() => {
    const initialFetch = async () => {
      const result = await getRutas();
      
      if(result.ok){
        setRutas(result.listadoRutas)
      }else{
        message.error('¡Hubo un problema!');
      }

      const resultUbicaciones = await getUbicaciones();
      
      if(resultUbicaciones.ok){
        setUbicaciones(resultUbicaciones.listadoUbicaciones)
      }else{
        message.error('¡Hubo un problema!');
      }

      handleLoading(false);
    };
    initialFetch();
  }, [dispatch]);


  const agregarData = async (data) => {
    var allRutas = [... rutas]

    var itemRutasOrigen = ubicaciones.find((item) => item.id == data.origen)
    if(typeof itemRutasOrigen !== 'undefined'){
        data.origenName =  itemRutasOrigen.nombre
    }else{
        data.origenName =  ""
    }

    var itemRutasDestino = ubicaciones.find((item) => item.id == data.destino)
    if(typeof itemRutasDestino !== 'undefined'){
        data.destinoName =  itemRutasDestino.nombre
    }else{
        data.destinoName =  ""
    }

    allRutas.unshift(data)
    setRutas(allRutas)
  }

  const actualizarData = async (data) => {
    var allRutas = [... rutas]
    var itemData = allRutas.find((item) => item.id == data.id)
    if(typeof itemData !== 'undefined'){
      var index = allRutas.indexOf(itemData);
      if (index != -1) {
        var dataSend = {... data}
        var itemRutasOrigen = ubicaciones.find((item) => item.id == data.origen)
        if(typeof itemRutasOrigen !== 'undefined'){
            dataSend.origenName =  itemRutasOrigen.nombre
        }else{
           dataSend.origenName =  ""
        }
    
        var itemRutasDestino = ubicaciones.find((item) => item.id == data.destino)
        if(typeof itemRutasDestino !== 'undefined'){
          dataSend.destinoName =  itemRutasDestino.nombre
        }else{
          dataSend.destinoName =  ""
        }


        allRutas[index] = dataSend
      }

    }
    setRutas(allRutas)
  };


  const save = async () => {
    try {
      const values = await form.validateFields();
      handleSending(true);

      var itemSend = {}
      itemSend.activo = true
      itemSend.destino = values.destino
      itemSend.origen = values.origen
      itemSend.recorrido = values.recorrido


      if(item == undefined){
        itemSend.fechaCreado = moment(new Date(), 'DD/MM/YYYY').toDate();
        const response =  await createDocument(`Rutas`,itemSend)
        itemSend.id = response.info.id
        message.success('Ruta creada');
        handleSending(false)
        agregarData(itemSend)
        setIsModalAsignar()
      }else{
        itemSend.fechaCreado = moment(new Date(), 'DD/MM/YYYY').toDate()
  

        const response =  await updateDocument(itemSend,`/Rutas/${item.id}`)
        console.log("response",response)
        if (response.ok === true) {
          message.success('Cambios realizados con éxito');
          itemSend.id = item.id
          itemSend.activo = true
          
          handleSending(false)
          actualizarData(itemSend)
          setIsModalAsignar()
          form.resetFields();
        } else {
          message.error('¡Hubo un problema! Inténtalo de nuevo');
        }
      }

     

    } catch (e) {
      console.log("====>",e)
      handleSending(false)
    }
  }
  
  const handleChangeDepartamento = (value: string) => {

    var listTipificacion = tipificacion.filter((data) => data.categoria == value)
    setTipificacionSelect(listTipificacion)
    const newValues = {};
    newValues.tipificacion = ""
    form.setFieldsValue(newValues);
  };

  const openEditor = (item) => {
    setItem(item);

    const newValues = {
      origen: item.origen,
      destino: item.destino,
      recorrido: item.recorrido
    };
    form.setFieldsValue(newValues);

    setIsModalAsignar(true);
  };

  const openNewItem = () => {
    setItem(null);

    const newValues = {
      origen: "",
      destino: "",
      recorrido: ""
    };
    form.setFieldsValue(newValues);

    setIsModalAsignar(true);
  };

  const confirmDelete = (idItem) => {
    Modal.confirm({
      title: '¿Estás segúro de eliminar esta ruta?',
      content: 'Esta información no se podrá recuperar.',
      okText: 'Eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      async onOk() {
        await removeRuta(idItem);
      },
      onCancel() {},
    });
  };

  const removeRuta = async (idItem) => {
    const info = {
      activo: false
    };

    const response =  await updateDocument(info,`/Rutas/${idItem}`)
    console.log("response",response)
    if (response.ok === true) {
      var rutasAll = [... rutas]

      const index = rutasAll.findIndex(el => el.id === idItem);
      if (index > -1) {
        rutasAll.splice(index, 1);
      }

      setRutas(rutasAll)

      message.success('Ruta eliminada correctamente');
    }else{
      message.error('¡Hubo un problema!');
    }
  };

  const columns = [
    {
      title: 'Origen',
      dataIndex: 'origenName',
      align: 'left',
      ...getColumnSearchProps('origenName'),
    },
    {
      title: 'Destino',
      dataIndex: 'destinoName',
      ...getColumnSearchProps('destinoName'),
    },
    {
      title: 'Recorrido',
      dataIndex: 'recorrido',
      render: (id, record) => (
        <div>
          {record.recorrido} Km
        </div>
      ),
      ...getColumnSearchProps('recorrido'),
    },
    {
      title: 'Editar',
      align: 'center',
      dataIndex: 'id',
      render: (id, record) => (
        <div className={styles.actions}>
          <div className={styles.edit} onClick={() => openEditor(record)}>
            <Edit />
          </div>
          <div className={styles.divider} />
          <div className={styles.delete} onClick={() => confirmDelete(id)}>
            <Trash />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.view}>
      <Header
        title="EDICIÓN DE RUTAS"
        back="/monitor"
        actions={
          <Button
            onClick={openNewItem}
            type="primary"
            size="large"
            className="main-buttonHeader">
            AGREGAR RUTA
          </Button>
        }
      />
      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <div>
          <Table
            columns={columns}
            
            dataSource={rutas}
            rowKey="id"
          />
        </div>
      )}



        <Modal 
        className='primary-modal'
        title="Ruta"
        visible={isModalAsignar}
        style={{ top: 20 }}
        onCancel={() => setIsModalAsignar(false)}
        footer = { <Row>

          <Col span={6} style={{textAlign:"left"}}>
            
              
            
          </Col>

          <Col span={12} style={{textAlign:"right"}}></Col>

          <Col span={6} style={{textAlign:"right"}}>
            <Button 
                // disabled={requests.isSaving}
                loading={loading}
                className={styles.btCerrar}
                type="primary" 
                shape="round" 
                style={{ width: "90%" }} 
                onClick={() => {
                  save()
                  //asignarAgenteTicket(item,itemAgente)
                }}
                >
                Guardar
            </Button>
          </Col>
        </Row> }>

        <div>
        
          <Form
            name="branch-editor"
            autoComplete="off"
            form={form}
            colon={false}
            requiredMark={false}
            onFinish={save}
          >

          
            
            <Row>
              <Col span={24}>
                <Form.Item
                  label={
                    <span className={styles.label}>
                      Origen
                    </span>
                  }
                  name="origen"
                  className={styles.itemColumn}
                  rules={[{required: true, message: 'Seleccione origen'}]}
                >
                <Select size="large" className={styles.input}>
                  {ubicaciones.map(branch => (
                    <Option key={branch.id} value={branch.id}>{branch.nombre}</Option>
                    ))}
                </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label={
                    <span className={styles.label}>
                      Destino   
                    </span>
                  }
                  name="destino"
                  className={styles.itemColumn}
                  rules={[{required: true, message: 'Seleccione destino'}]}
                >
                <Select size="large" className={styles.input}>
                  {ubicaciones.map(branch => (
                    <Option key={branch.id} value={branch.id}>{branch.nombre}</Option>
                    ))}
                </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label={
                    <span className={styles.label}>
                      Recorrido (km)
                    </span>
                  }
                  name="recorrido"
                  className={styles.itemColumn}
                  rules={[{required: true, message: 'Ingrese recorrido'}]}
                >
                <Input size="large" className={styles.input} />
                </Form.Item>
              </Col>
            </Row>

          
            
            
          </Form>
        </div>

        
        </Modal>

    </div>
  );
};

export default RutasUI;
